import Vue from 'vue';

const countryZips = {
    // DE
    276: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    // AT
    40: [1, 2, 3, 4, 5, 6, 7, 8, 9],
};

export default Vue.component('SearchZipCodes', {
    props: {
        regions: {
            type: Array,
            required: true,
        },
        groupSelector: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            slot: null,
            group: {},
        };
    },
    watch: {
        regions() {
            this.hideFilteredZips();
        },
    },
    methods: {
        hideFilteredZips() {
            for (const prop in this.group) {
                const label = this.getInputLabel(this.group[prop]);
                const input = this.group[prop];
                if (Object.prototype.hasOwnProperty.call(this.group, prop) && this.zipCodeEnabled(parseInt(input.value))) {
                    this.show(input);
                    this.show(label);
                } else if (Object.prototype.hasOwnProperty.call(this.group, prop)) {
                    this.hide(label);
                    this.hide(input);
                    this.uncheck(input);
                }
            }
        },
        uncheck(input) {
            input.checked = false;
        },
        zipCodeEnabled(zipCode) {
            let enabled = false;
            this.regions.forEach(region => {
                if (countryZips[region].indexOf(zipCode) > -1) {
                    enabled = true;
                }
            });

            return enabled;
        },
        getInputLabel(inputElement) {
            const id = inputElement.getAttribute('id');
            const label = document.querySelector(`[for=${ id }]`);

            return label;
        },
        hide(element) {
            element.classList.add('hidden');
        },
        show(element) {
            element.classList.remove('hidden');
        },
    },
    mounted() {
        this.slot = this.$slots.default[0];
        const _this = this; // eslint-disable-line @typescript-eslint/no-this-alias

        if (this.slot && this.slot.elm) {
            this.slot.elm.querySelectorAll(this.groupSelector).forEach(el => {
                _this.group[el.value] = el;
            });
        }

    },
    template: `
        <div>
            <slot></slot>
        </div>
    `,
});
